//src/rtkQuery/features/hooks/useForgetPasswordService.ts

import { useForgotPasswordMutation } from '@/rtkQuery/features/services/auth/forgetPasswordApi.slice';
import { toastService } from '@/utils/toastService';

export const useForgetPasswordService = () => {
  const [forgotPasswordMutation, forgotPasswordState] = useForgotPasswordMutation();
  const forgotPassword = async (email: string) => {
    const defaultSuccess = 'Instructions will be sent if a matching patient account is found.';
    const defaultError = 'Could not send reset email.';

    try {
      const result = await forgotPasswordMutation(email);

      const isSuccess = result?.data?.Result?.toLowerCase() === 'success';
      const message = result?.data?.Message || 
                      (isSuccess ? defaultSuccess : defaultError);

      if (isSuccess) {
        toastService.success(message);
      } else {
        toastService.error(message);
      }

      return {
        result: isSuccess,
        message,
        raw: result,
      };
    } catch (error) {
      const errorMessage = 'An unexpected error occurred while sending reset link.';
      toastService.error(errorMessage);

      return {
        result: false,
        message: errorMessage,
        raw: null,
      };
    }
  };

  return {      
    forgotPassword,
    forgotPasswordData: forgotPasswordState.data,
    forgotPasswordLoading: forgotPasswordState.isLoading,
    forgotPasswordSuccess: forgotPasswordState.isSuccess,
    forgotPasswordError: forgotPasswordState.isError,
    forgotPasswordStatus: forgotPasswordState.status, 
  };
};
